import { makeStyles } from "@material-ui/styles"
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles((theme) => ({
  priceCell: {
    "--width": `${CELL_WIDTHS.PRICE.SMALL}px`,
    width: "var(--width)",
    minWidth: "var(--width)",
  },
  cellMini: {
    "--width": `${CELL_WIDTHS.PRICE.MINI}px`,
  },
  cellMedium: {
    "--width": `${CELL_WIDTHS.PRICE.MEDIUM}px`,
  },
  cellLarge: {
    "--width": `${CELL_WIDTHS.PRICE.LARGE}px`,
  },
  priceCellBody: {
    color: theme.palette.text.primary,
  },
  priceContainer: {
    height: 24,
  },
  priceContainerBackground: {
    borderRadius: 3,
    backgroundColor: theme.palette.primary.main + "0d",
  },
  extendPadding: {
    paddingRight: "16px !important",
    width: "calc(var(--width) + 16px)",
    minWidth: "calc(var(--width) + 16px)",
  },
  isSticky: {
    // right: CELL_WIDTHS.VISIBILITY,
    zIndex: 4,
    position: "sticky",
    right: ({ colName }) => `var(--right-${colName})`,
  },
  dynamicWidth: {
    zIndex: ({ colName }) => `var(--index-${colName})`,
    width: ({ colName, extendPadding }) => extendPadding ? `calc(var(--maxWidth-${colName}) + 16px)` : `var(--maxWidth-${colName})`,
    minWidth: ({ colName, extendPadding }) => extendPadding ? `calc(var(--minWidth-${colName}) + 16px)` : `var(--minWidth-${colName})`,
  }
}));

export default useStyle;
